const translations = {
  en: {
    // Navigation
    feed: 'Feed',
    myKudos: 'My Kudos',
    team: 'Team',
    admin: 'Admin',
    switchUser: 'Switch User',
    signOut: 'Sign Out',
    help: 'Help & About',

    // Feed page
    recognizeColleague: 'Recognize a colleague',
    giveRecognition: 'Give Recognition',
    recent: 'Recent',
    popular: 'Popular',
    myTeam: 'My Team',
    noRecognitionsYet: 'No recognitions yet',
    beFirstToRecognize: 'Be the first to recognize a colleague!',
    noTeamRecognitions: 'No team recognitions yet',
    noTeamRecognitionsDesc: 'Recognitions involving your direct reports will appear here.',
    loadMore: 'Load More',

    // Recognition card
    recognized: 'recognized',
    tinyWin: 'Tiny Win 🎉',
    recognitionSent: 'Recognition Sent!',
    gotIt: 'Got It',
    addComment: 'Add a comment...',
    manager: 'Manager',
    translate: 'Translate',
    showOriginal: 'Original',
    translating: 'Translating...',

    // Sidebar
    topGivers: 'Top Givers (Last 30 Days)',
    mostRecognized: 'Most Recognized (Last 30 Days)',
    noDataYet: 'No data yet',
    loading: 'Loading...',

    // Profile
    received: 'Received',
    given: 'Given',
    likes: 'Likes',
    comments: 'Comments',
    badges: 'Badges',
    noBadges: 'No badges earned yet',
    badgeProgress: 'Badge Progress',
    coreValues: 'Core Values',
    fundamentals: 'Fundamentals',
    noProgressYet: 'No progress yet',
    noRecognitionsReceived: 'No recognitions received yet',
    keepUpGreatWork: 'Keep up the great work and recognitions will come!',
    noRecognitionsGiven: 'No recognitions given yet',
    startRecognizing: 'Start recognizing your colleagues for their great work!',

    // Rewards
    pts: 'pts',
    cancel: 'Cancel',
    confirm: 'Confirm',
    pending: 'Pending',
    approved: 'Approved',
    fulfilled: 'Fulfilled',
    cancelled: 'Cancelled',

    // Recognition modal
    newRecognition: 'New Recognition',
    whoRecognize: 'Who would you like to recognize?',
    searchColleagues: 'Search colleagues...',
    selectCoreValue: 'Select a Core Value',
    selectFundamental: 'Select a Fundamental',
    writeMessage: 'Write your message',
    messagePrompt: 'What did they do that deserves recognition?',
    submit: 'Submit Recognition',
    submitting: 'Submitting...',

    // Admin Dashboard
    adminDashboard: 'Admin Dashboard',
    accessDenied: 'Access Denied',
    adminPrivilegesRequired: 'Admin privileges required.',
    loadingAdminDashboard: 'Loading admin dashboard...',

    // Admin tabs
    users: 'Users',
    tags: 'Tags',
    recognitions: 'Recognitions',
    leaderboard: 'Leaderboard',
    reports: 'Reports',

    // User Management
    userManagement: 'User Management',
    addUser: 'Add User',
    searchByNameEmail: 'Search by name, email, or employee ID...',
    search: 'Search',
    clear: 'Clear',
    name: 'Name',
    email: 'Email',
    department: 'Department',
    location: 'Location',
    roles: 'Roles',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    employeeId: 'Employee ID',
    selectDepartment: 'Select Department',
    selectLocation: 'Select Location',
    noManager: 'No Manager',
    eltMember: 'ELT Member',
    updateUser: 'Update User',
    createUser: 'Create User',
    give: 'Give',
    bal: 'Bal',

    // Balances

    // Rewards Management
    description: 'Description',
    active: 'Active',
    enable: 'Enable',
    disable: 'Disable',
    create: 'Create',
    update: 'Update',

    // Tags Management
    tagsManagement: 'Tags Management',
    addTag: 'Add Tag',
    coreValue: 'Core Value',
    fundamental: 'Fundamental',
    internalName: 'Internal Name',
    displayName: 'Display Name',
    usage: 'Usage',

    // Redemptions
    all: 'All',
    date: 'Date',
    user: 'User',
    status: 'Status',
    notes: 'Notes',
    approve: 'Approve',
    markFulfilled: 'Mark Fulfilled',
    addNote: 'Add Note',
    save: 'Save',

    // Badges
    badgeManagement: 'Badge Management',
    awardBadge: 'Award Badge',
    selectUser: 'Select User',
    badgeName: 'Badge Name',
    internalMilestone: 'Internal Milestone',
    k2Value: 'K2 Value',
    fundamentallyFocused: 'Fundamentally Focused',
    award: 'Award',
    remove: 'Remove',
    badge: 'Badge',
    type: 'Type',

    // Points
    reason: 'Reason',
    adjust: 'Adjust',

    // Recognition Reports
    recognitionReports: 'Recognition Reports',
    exportCsv: 'Export CSV',
    allDepartments: 'All Departments',
    allLocations: 'All Locations',
    apply: 'Apply',
    giver: 'Giver',
    receiver: 'Receiver',
    dept: 'Dept',

    // Leaderboard
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    thisYear: 'This Year',
    allTime: 'All Time',
    topGiversLeaderboard: 'Top Givers',
    topReceivers: 'Top Receivers',

    // Reports
    executiveSummary: 'Executive Summary',
    participation: 'Participation',
    inactiveUsers: 'Inactive Users',
    trends: 'Trends',
    recognitionFlow: 'Recognition Flow',
    managerEngagement: 'Manager Engagement',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    last60Days: 'Last 60 days',
    last90Days: 'Last 90 days',
    printCurrent: 'Print Current',
    printAll: 'Print All',
    loadingReport: 'Loading report...',

    // Report labels
    participationRate: 'Participation Rate',
    recognitionsThisMonth: 'Recognitions This Month',
    recognitionsThisWeek: 'Recognitions This Week',
    topValueThisMonth: 'Top Value This Month',
    badgesAwarded: 'Badges Awarded',
    totalUsers: 'Total Users',
    activeGivers: 'Active Givers (This Month)',
    activeReceivers: 'Active Receivers (This Month)',
    usersWhoGave: 'Users Who Gave',
    usersWhoReceived: 'Users Who Received',
    byDepartment: 'By Department',
    byLocation: 'By Location',
    rate: 'Rate',
    days: 'days',
    lastGiven: 'Last Given',
    lastReceived: 'Last Received',
    never: 'Never',
    showingFirst: 'Showing first',
    of: 'of',
    recognitionActivity: 'Recognition Activity (Weekly)',
    crossDeptFlow: 'Cross-Department Recognition Flow',
    fromTo: 'Rows = Giver Department, Columns = Receiver Department',
    managerRecognitionActivity: 'Manager Recognition Activity',
    directReports: 'Direct Reports',
    recognitionsToTeam: 'Recognitions to Team',
    recognitionRate: 'Recognition Rate',
    coreValuesUsage: 'Core Values Usage',
    value: 'Value',
    count: 'Count',
    top10MostUsed: 'Top 10 Most Used',
    bottom10LeastUsed: 'Bottom 10 Least Used',
    allFundamentals: 'All Fundamentals',
    percentage: 'Percentage',
    k2KudosReports: 'K2 Kudos Reports',
    generated: 'Generated',
    period: 'Period',
  },
  zh: {
    // Navigation
    feed: '动态',
    myKudos: '我的表彰',
    team: '团队',
    admin: '管理',
    switchUser: '切换用户',
    signOut: '退出登录',
    help: '帮助与关于',

    // Feed page
    recognizeColleague: '表彰同事',
    giveRecognition: '发送表彰',
    recent: '最新',
    popular: '热门',
    myTeam: '我的团队',
    noRecognitionsYet: '暂无表彰',
    beFirstToRecognize: '成为第一个表彰同事的人！',
    noTeamRecognitions: '暂无团队表彰',
    noTeamRecognitionsDesc: '涉及您直接下属的表彰将显示在这里。',
    loadMore: '加载更多',

    // Recognition card
    recognized: '表彰了',
    tinyWin: '小小的胜利 🎉',
    recognitionSent: '表彰已发送！',
    gotIt: '知道了',
    addComment: '添加评论...',
    manager: '经理',
    translate: '翻译',
    showOriginal: '原文',
    translating: '翻译中...',

    // Sidebar
    topGivers: '表彰最多 (近30天)',
    mostRecognized: '获赞最多 (近30天)',
    noDataYet: '暂无数据',
    loading: '加载中...',

    // Profile
    received: '获得',
    given: '给予',
    likes: '点赞',
    comments: '评论',
    badges: '徽章',
    noBadges: '暂未获得徽章',
    badgeProgress: '徽章进度',
    coreValues: '核心价值观',
    fundamentals: '基本准则',
    noProgressYet: '暂无进度',
    noRecognitionsReceived: '暂未收到表彰',
    keepUpGreatWork: '继续努力，表彰会来的！',
    noRecognitionsGiven: '暂未发送表彰',
    startRecognizing: '开始表彰您出色的同事！',

    // Rewards
    pts: '分',
    cancel: '取消',
    confirm: '确认',
    pending: '待处理',
    approved: '已批准',
    fulfilled: '已完成',
    cancelled: '已取消',

    // Recognition modal
    newRecognition: '新表彰',
    whoRecognize: '您想表彰谁？',
    searchColleagues: '搜索同事...',
    selectCoreValue: '选择核心价值观',
    selectFundamental: '选择基本准则',
    writeMessage: '撰写您的消息',
    messagePrompt: '他们做了什么值得表彰的事？',
    submit: '提交表彰',
    submitting: '提交中...',

    // Admin Dashboard
    adminDashboard: '管理面板',
    accessDenied: '访问被拒绝',
    adminPrivilegesRequired: '需要管理员权限。',
    loadingAdminDashboard: '加载管理面板中...',

    // Admin tabs
    users: '用户',
    tags: '标签',
    recognitions: '表彰',
    leaderboard: '排行榜',
    reports: '报告',

    // User Management
    userManagement: '用户管理',
    addUser: '添加用户',
    searchByNameEmail: '按姓名、邮箱或员工ID搜索...',
    search: '搜索',
    clear: '清除',
    name: '姓名',
    email: '邮箱',
    department: '部门',
    location: '地区',
    roles: '角色',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    employeeId: '员工ID',
    selectDepartment: '选择部门',
    selectLocation: '选择地区',
    noManager: '无经理',
    eltMember: 'ELT成员',
    updateUser: '更新用户',
    createUser: '创建用户',
    give: '给予',
    bal: '余额',

    // Balances

    // Rewards Management
    description: '描述',
    active: '启用',
    enable: '启用',
    disable: '禁用',
    create: '创建',
    update: '更新',

    // Tags Management
    tagsManagement: '标签管理',
    addTag: '添加标签',
    coreValue: '核心价值观',
    fundamental: '基本准则',
    internalName: '内部名称',
    displayName: '显示名称',
    usage: '使用次数',

    // Redemptions
    all: '全部',
    date: '日期',
    user: '用户',
    status: '状态',
    notes: '备注',
    approve: '批准',
    markFulfilled: '标记完成',
    addNote: '添加备注',
    save: '保存',

    // Badges
    badgeManagement: '徽章管理',
    awardBadge: '授予徽章',
    selectUser: '选择用户',
    badgeName: '徽章名称',
    internalMilestone: '内部里程碑',
    k2Value: 'K2价值观',
    fundamentallyFocused: '基本准则专注',
    award: '授予',
    remove: '移除',
    badge: '徽章',
    type: '类型',

    // Points
    reason: '原因',
    adjust: '调整',

    // Recognition Reports
    recognitionReports: '表彰报告',
    exportCsv: '导出CSV',
    allDepartments: '所有部门',
    allLocations: '所有地区',
    apply: '应用',
    giver: '给予者',
    receiver: '接收者',
    dept: '部门',

    // Leaderboard
    thisWeek: '本周',
    thisMonth: '本月',
    thisYear: '今年',
    allTime: '全部时间',
    topGiversLeaderboard: '表彰最多',
    topReceivers: '获赞最多',

    // Reports
    executiveSummary: '执行摘要',
    participation: '参与度',
    inactiveUsers: '不活跃用户',
    trends: '趋势',
    recognitionFlow: '表彰流向',
    managerEngagement: '经理参与度',
    last7Days: '过去7天',
    last30Days: '过去30天',
    last60Days: '过去60天',
    last90Days: '过去90天',
    printCurrent: '打印当前',
    printAll: '打印全部',
    loadingReport: '加载报告中...',

    // Report labels
    participationRate: '参与率',
    recognitionsThisMonth: '本月表彰',
    recognitionsThisWeek: '本周表彰',
    topValueThisMonth: '本月热门价值观',
    badgesAwarded: '授予徽章',
    totalUsers: '总用户数',
    activeGivers: '活跃给予者（本月）',
    activeReceivers: '活跃接收者（本月）',
    usersWhoGave: '给予表彰的用户',
    usersWhoReceived: '收到表彰的用户',
    byDepartment: '按部门',
    byLocation: '按地区',
    rate: '比率',
    days: '天',
    lastGiven: '最后给予',
    lastReceived: '最后收到',
    never: '从未',
    showingFirst: '显示前',
    of: '共',
    recognitionActivity: '表彰活动（每周）',
    crossDeptFlow: '跨部门表彰流向',
    fromTo: '行 = 给予部门，列 = 接收部门',
    managerRecognitionActivity: '经理表彰活动',
    directReports: '直属下属',
    recognitionsToTeam: '团队表彰数',
    recognitionRate: '表彰率',
    coreValuesUsage: '核心价值观使用情况',
    value: '价值观',
    count: '数量',
    top10MostUsed: '使用最多前10',
    bottom10LeastUsed: '使用最少后10',
    allFundamentals: '所有基本准则',
    percentage: '百分比',
    k2KudosReports: 'K2 Kudos 报告',
    generated: '生成时间',
    period: '时间段',
  }
};

export function t(key, language = 'en') {
  return translations[language]?.[key] || translations.en[key] || key;
}

export default translations;
